import React from 'react'
import SensorInfoPanel from './SensorInfoPanel';
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { Button, Tabs, Tag, Tooltip } from '@sede-enterprise/shell-ds-react-framework';
import SensorDetailsChart from './SensorDetailsChart';
import RelatedSensorData from './RelatedSensorData';
import SensorAlertsTab from './SensorAlertsTab';
import SensorFeatureAnalysis from './SensorFeatureAnalysis';
import { ChevronRight, InfoCircle } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { DEFAULT_METRIC_SPEC, ratingSentimentMap } from '../../util/constants';
import { helperTexts } from '../../util/helperTexts';
import { useMetricChartHook } from '../../components/MetricChart/useMetricChartHook';

const helpContents = helperTexts.sensorInfo;



const SensorDetailsScreen = (
    {
        units,
        prodUnit,
        rating,
        sensorID,
        cmlID,
        isRealSensor,
        clId,
        isUninstalled,
        equipmentId,
        cmlName,
        sensorAlertData,
        site,
        sensorData,
        alertThresholdUpdate,
        setAlertThresholdUpdate,
    }
) => {

    const {
        data,
        metricData,
        loading,
        start,
        setStart,
        end,
        setEnd,
        interval,
        setSelectedInterval,
        intervalOpts,
        forecastMonths,
        setSelectedMonths,
        forecastMonthsOpts,
        setRequestParams,
        formDirty,
        refreshChartData,
        refreshScatterData,
        scaled,
        setScaled,
    } = useMetricChartHook(DEFAULT_METRIC_SPEC);


    const isNorco = site === "SNR" ? true : false;
    const isNorcoWest = isNorco && prodUnit === "REFINING WEST";


    return (


        <div className='parent-container' id='sensor-details-screen-id-1'>

            <div className='content-container' id='sensor-details-screen-id-2'>
                {/* <br /> */}
                <div className='content-header'>
                    <div className='details-title'>
                        <h4>Equipment: {equipmentId?.length > 13 ? <Tooltip className='remanent-tooltip' placement='bottom'
                            overlay={<div className='tooltip-content'>{equipmentId}</div>}
                            trigger={<Button style={{ padding: "0px" }} variant='transparent' onClick={() => { }}>{equipmentId?.substring(0, 13)}...</Button>} /> : equipmentId}</h4>
                        <ChevronRight />

                        <h4>CL:  <Link
                            className="link"
                            to={`/cls/${encodeURIComponent(clId)}/details`}

                        >
                            {clId}
                        </Link></h4>
                        <ChevronRight />

                        <h4>CML:   <Link
                            className="link"
                            to={`/cmls/${encodeURIComponent(cmlID)}/details`}
                            id='top-cml-id-7'
                        >
                            {cmlName}
                        </Link>
                        </h4>
                        <ChevronRight />

                        <h4>Sensor: <span className={(!isRealSensor || isUninstalled) && 'redContent'}>{isRealSensor ? sensorID : 'No Sensor'}</span></h4>
                    </div>
                    <div className='rating-container'>
                        <Tag
                            sentiment={ratingSentimentMap[rating]}
                            variant='outlined'
                            shape='round'
                            id='sensor-list-id-59'
                        >
                            {rating}
                        </Tag>
                        <Tooltip className='tooltip' placement='bottom' overlay={<div className='tooltip-content'>{isNorcoWest ? helpContents.norco : !isRealSensor ? helpContents.noSensorRating : helpContents.sensorRating}</div>} trigger={
                            <Button size='xsmall' variant='transparent' iconOnly icon={<InfoCircle />} />
                        } />
                    </div>
                </div>
                <Tabs id='sensor-details-screen-id-3' tabBarStyle={{
                    justifyContent: 'flex-start',
                    // paddingLeft: '5%',
                    borderBottom: '1px solid #E0E0E0',
                    marginBottom: '20px'
                }}
                    defaultActiveKey='features'
                    items={[
                        {
                            label: 'Details',
                            key: 'details',
                            children: <SensorInfoPanel
                                units={units}
                                isRealSensor={isRealSensor}
                                prodUnit={prodUnit}
                                sensorID={sensorID}
                                site={site}
                                alertThresholdUpdate={alertThresholdUpdate}
                                start={start}
                                end={end}
                                forecastMonths={forecastMonths}
                            />
                        },
                        {
                            label: 'Features',
                            key: 'features',
                            children: <SensorDetailsChart
                                units={units}
                                prodUnit={prodUnit}
                                sensorID={sensorID}
                                site={site}
                                data={data}
                                metricData={metricData}
                                sensorData={sensorData}
                                loading={loading}
                                start={start}
                                setStart={setStart}
                                end={end}
                                setEnd={setEnd}
                                alertThresholdUpdate={alertThresholdUpdate}
                                interval={interval}
                                setSelectedInterval={setSelectedInterval}
                                intervalOpts={intervalOpts}
                                forecastMonths={forecastMonths}
                                setSelectedMonths={setSelectedMonths}
                                forecastMonthsOpts={forecastMonthsOpts}
                                setRequestParams={setRequestParams}
                                formDirty={formDirty}
                                refreshChartData={refreshChartData}
                                refreshScatterData={refreshScatterData}
                                scaled={scaled}
                                setScaled={setScaled}
                            />
                        },
                        {
                            label: 'What If Analysis',
                            key: 'analysis',
                            children: <SensorFeatureAnalysis
                                units={units}
                                start={start}
                                end={end}
                                isRealSensor={sensorData.isRealSensor}
                                sensorID={sensorID}
                            />
                        },
                        {
                            label: 'Alert Report',
                            key: 'sensorAlerts',
                            children: <SensorAlertsTab
                                units={units}
                                site={site}
                                isRealSensor={isRealSensor}
                                sensorAlertThreshold={sensorData.alertThreshold}
                                sensorAlertData={sensorAlertData}
                                start={start}
                                end={end}
                                sensorID={sensorID}
                                setAlertThresholdUpdate={setAlertThresholdUpdate}
                                alertThresholdUpdate={alertThresholdUpdate}
                            />
                        },
                        {
                            label: 'Related Sensor Data',
                            key: 'related',
                            children: <RelatedSensorData
                                sensorData={sensorData}
                                cmlID={cmlID}
                                sensorID={sensorID}
                                cmlName={cmlName}
                            />
                        },
                    ]}
                />
            </div>
        </div>

    )
}

export default SensorDetailsScreen